<template>
  <div v-if="inviter">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <br />
          <Pagination :numberOfDots="4" :numberOfVisitedDots="3" />
          <div class="clearfix"></div>
          <div class="header-wrapper">
            <h2 class="text-primary-fh left-header" v-html="inviteHeader"></h2>
          </div>
          <div class="clearfix"></div>
          <p v-html="inviteText"></p>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="margin-top-30"></div>
          <button class="btn btn-primary btn-lg btn-block" @click="verifyInvite(true)">Ja</button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block" @click="verifyInvite(false)">Nej</button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import { getKinshipType } from '../plugins/relationhandler'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'verifyinvite',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null,
      inviter: null
    }
  },
  methods: {
    getInviter () {
      let loader = this.$loading.show()
      axios._get(config.inviteUri).then(response => {
        loader.hide()
        this.inviter = response.data.invitationData
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    verifyInvite (choice) {
      if (choice !== null) {
        const invUrl = this.inviter.invitationLink
        let loader = this.$loading.show()
        axios.postInvite(config.inviteUri, choice, invUrl).then((response) => {
          if (response.status === 200) {
            loader.hide()
            if (choice) {
              this.$router.push('verifydiagnose')
            } else {
              this.$router.push('errorinvite')
            }
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    },
    kinshipType (famRel) {
      if (famRel) {
        const result = getKinshipType(famRel)
        return result
      }
    }
  },
  computed: {
    inviteHeader () {
      if (this.data !== null) {
        return this.data.screening.verifyinviteheader
          .replace('{relationType}', this.kinshipType(this.inviter.relationTypeId).toLowerCase())
          .replace('{indexPatient}', this.inviter.indexPatientName)
      }
    },
    inviteText () {
      if (this.data !== null) {
        return this.data.screening.verifyinvitetext
          .replace('{indexPatient}', this.inviter.indexPatientName)
      }
    }
  },
  beforeMount () {
    this.getInviter()
  },
  metaInfo () {},
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            verifyinviteheader
            verifyinvitetext
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.page-item {
  color: transparent !important;
}
.margin-top-30 {
  margin-top: 30px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/VerifyInvite.vue